/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ConversationClosedPayloadSideEffectType =
  (typeof ConversationClosedPayloadSideEffectType)[keyof typeof ConversationClosedPayloadSideEffectType];

export const ConversationClosedPayloadSideEffectType = {
  conversation_closed: "conversation_closed",
} as const;
